module.exports = __webpack_public_path__ + "static/media/Resume.ce4bf66b.pdf";